export const constant = {
	selector: {
		pdfLinkExport: '.js-pdf-export',
		format: 'data-pdf-export-format',
		pdfExportLink: 'data-link-pdf-export',
		pdfExportDownloadLink: 'data-link-pdf-export-download',
	},
}
